"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var index_1 = require("../../index");
function Editor(_a) {
    var description = _a.description, onChange = _a.onChange;
    var editorRef = react_1.useRef();
    var _b = editorRef.current || {}, CKEditor = _b.CKEditor, ClassicEditor = _b.ClassicEditor;
    var _c = react_1.useState(false), loaded = _c[0], setLoaded = _c[1];
    var config = {
        toolbar: ['bold', 'italic', 'link', '|'],
        link: {
            addTargetToExternalLinks: true,
            defaultProtocol: 'http://'
        },
    };
    react_1.useEffect(function () {
        editorRef.current = {
            CKEditor: require('@ckeditor/ckeditor5-react').CKEditor,
            ClassicEditor: require('@ckeditor/ckeditor5-build-classic'),
        };
        setLoaded(true);
    }, []);
    if (loaded) {
        return react_1.default.createElement("div", { className: 'storybook-forms-editor' },
            react_1.default.createElement(index_1.Forms.Label, null, "Omschrijving van de video"),
            react_1.default.createElement(CKEditor, { className: 'storybook-forms-editor', config: config, editor: ClassicEditor, data: description, onChange: function (event, editor) {
                    onChange(editor.getData());
                } }));
    }
    else {
        return react_1.default.createElement("div", null, "Loading");
    }
}
exports.default = Editor;
